import { requestApi } from '@app/api';
import { withDocument } from '@app/api/paths';

/**
 * POST 현재 서명 순서 참여자들에게 서명 알림 재전송
 *
 * Endpoint path is modified in standardize-document-content
 * @see https://www.notion.so/modusign/bb8e24e723434ecc946dfecb85db5ee3#3858988d99ab47f1993ceb652c10038f
 */
export function postDocumentsRemindCurrentParticipants({
  documentId,
  workspaceId,
}: {
  documentId: string;
  workspaceId: string;
}) {
  return requestApi({
    url: withDocument(
      `/workspaces/${workspaceId}/documents/${documentId}/participants/current/remind-signing`
    ),
    method: 'POST',
    credentials: true,
  });
}
